import React from 'react';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { InputBox } from 'atoms/InputBox';
import { isCateringDisposition } from 'common/utilities/utils';
import { getQtySelectorClassName } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { onKeyDownPress } from 'molecules/QuantityModifierAddToCart/QuantityModifierAddToCart';

export const decreaseQtyCheck = (itemCount, itemDefaultQty, defaultQuantity, minItemCountPerLineItem) => {
  return (
    (itemCount > itemDefaultQty && getCheckItemDefalutQtyEqualStatus(itemCount, defaultQuantity)) ||
    (minItemCountPerLineItem === 0 && itemCount > 0)
  );
};
export const getCheckItemDefalutQtyEqualStatus = (count, qty) => {
  return count !== qty;
};
const QuantityModifier = props => {
  const {
    itemQuantity: itemDefaultQty,
    itemCount,
    updateItemQuantity,
    quantityAction,
    item,
    itemName,
    maxItemCountPerLineItem,
    hideChild = false,
    type = '',
    dispositionType,
    handleQuantityForCatering,
    inputType = '',
    onKeyPressHandler = onKeyDownPress,
    defaultQuantity,
    modgrpMax,
    savedCustomizedModifier,
    minItemCountPerLineItem,
  } = props;
  const { quantityDecreseText, quantityIncreaseText, quantityUpdateText } = TRANSLATE_MAPPING_KEY;
  var dname = `${translateWithI18Next(quantityDecreseText)} ${itemName}`;
  var iname = `${translateWithI18Next(quantityIncreaseText)} ${itemName}`;
  const cateringInputButtonClass =
    isCateringDisposition(dispositionType) && itemCount === 0 ? 'cateringInputChangedZero' : '';

  return (
    <div
      className={`cart-food-quantity-change cart-food-quantity-change-sopac ${getQtySelectorClassName(
        dispositionType,
      )}`}
    >
      {decreaseQtyCheck(itemCount, itemDefaultQty, defaultQuantity, minItemCountPerLineItem) ? (
        <ButtonComp
          className={`button quantity-decrease ${itemCount !== 0 && 'red-quantity-decrease'}`}
          ariaLable={dname}
          onClickHandler={event => updateItemQuantity(item, quantityAction.Decrease, event)}
          data-testid='quantity-minus'
          type={type}
        >
          {!hideChild && <span>-</span>}
        </ButtonComp>
      ) : (
        <ButtonComp
          className={`button quantity-decrease ${
            itemCount !== 0 && !getCheckItemDefalutQtyEqualStatus(itemCount, itemDefaultQty) && 'red-quantity-decrease'
          } ${getCheckItemDefalutQtyEqualStatus(itemCount, itemDefaultQty) && 'quantity-decrease-disable'}`}
          disabled
          data-testid='quantity-minus'
          ariaLable='minus'
        >
          {!hideChild && <span>-</span>}
        </ButtonComp>
      )}
      {isCateringDisposition(dispositionType) ? (
        <InputBox
          aria-label='Enter quantity'
          className='quantity-input'
          id='inputFocus'
          data-testid='quantity-input'
          inputMode='numeric'
          maxLength='3'
          onChange={handleQuantityForCatering}
          value={itemCount}
          autocomplete='off'
          inputType={inputType}
          onKeyPressHandler={onKeyPressHandler}
        />
      ) : (
        <span className='cart-food-quantity'>{itemCount}</span>
      )}
      <span className='sr-only' role='alert'>{`${translateWithI18Next(quantityUpdateText)} ${itemCount}`}</span>
      <ButtonComp
        className={`transparent-btn button quantity-increase ${
          itemCount !== 0 ? 'red-quantity-increase' : 'gray-quantity-increase'
        } ${
          savedCustomizedModifier?.totalQuantity === modgrpMax && itemCount === 0 && 'red-quantity-increase'
        } ${cateringInputButtonClass}`}
        ariaLable={iname}
        data-testid='quantity-plus'
        type={type}
        onClickHandler={event => updateItemQuantity(item, quantityAction.Increase, event)}
        disabled={!!(maxItemCountPerLineItem !== 0 && itemCount >= maxItemCountPerLineItem)}
      >
        {!hideChild && <span>+</span>}
      </ButtonComp>
    </div>
  );
};
export default QuantityModifier;
